var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageListShow',{attrs:{"image-list":_vm.imgList}})
}
var staticRenderFns = []

export { render, staticRenderFns }